var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#272C4D"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#272C4D",
    strokeWidth: 0.5,
    d: "M19.947 4.467c-2.802 0-6.173.835-9.879 2.07-6.241 2.081-7.565 5.473-7.565 7.566 0 2.825.59 8.288 5.674 11.726 2.938 1.987 6.233 3.611 9.443 3.611 1.355 0 2.695-.29 3.986-.963 4.35-2.27 4.917-7.943 4.917-12.294 0-4.35.234-9.036-1.702-10.402-1.306-.922-2.957-1.314-4.874-1.314m0 .378c1.947 0 3.47.407 4.656 1.245 1.587 1.12 1.566 5.032 1.546 8.815-.002.427-.004.854-.004 1.278 0 4.078-.489 9.754-4.714 11.959-1.17.61-2.452.92-3.81.92-2.684 0-5.704-1.16-9.232-3.546C3.837 22.438 2.88 17.61 2.88 14.103c0-.856.236-2.166 1.358-3.55C5.474 9.032 7.476 7.8 10.188 6.897c4.197-1.399 7.298-2.05 9.759-2.05",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 0.975,
    d: "M21.717 4.539L24.365 0M26.445 10.213L31.174 7.755M26.445 17.022L31.174 17.022M25.31 24.21L30.228 26.857M21.528 28.56L24.365 32.342M14.529 28.749L14.529 31.964M8.855 26.29L6.586 30.451M4.883 22.318L.912 24.777M2.992 17.022L.344 17.022M3.594 10.898L0 9.007M8.666 6.998L5.073.946M14.151 5.296L14.151 1.135M22.379 11.916c0 1.096-.89 1.986-1.986 1.986-1.097 0-1.986-.89-1.986-1.986 0-1.097.889-1.986 1.986-1.986s1.986.889 1.986 1.986zM9.896 14.753c0 1.096-.89 1.986-1.986 1.986-1.097 0-1.986-.89-1.986-1.986 0-1.097.889-1.986 1.986-1.986 1.096 0 1.986.889 1.986 1.986zM21.433 21.845c0 1.776-1.44 3.216-3.215 3.216-1.776 0-3.216-1.44-3.216-3.216 0-1.775 1.44-3.215 3.216-3.215 1.775 0 3.215 1.44 3.215 3.215z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.3c18e621361480e8272e676738157c04.svg";
export { ForwardRef as ReactComponent };